import type { FunctionComponent } from "react"

import { Commitments } from "@/modules/companies/client/components/Commitments/Commitments"
import { CompanyEcosystem } from "@/modules/companies/client/components/CompanyEcosystem/CompanyEcosystem"
import { DeepDive } from "@/modules/companies/client/components/DeepDive/DeepDive"
import { Exclusivity } from "@/modules/companies/client/components/Exclusivity/Exclusivity"
import { What } from "@/modules/companies/client/components/What/What"
import { WorkThere } from "@/modules/companies/client/components/WorkThere/WorkThere"

export const Information: FunctionComponent = () => (
  <>
    <Exclusivity />
    <What />
    <WorkThere />
    <DeepDive />
    <Commitments />
    <CompanyEcosystem />
  </>
)
